import React, { useEffect, useRef } from "react";

const HealthSciencesSolutions = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
      .solutions-container {
        width: 100%;
        padding: 40px 20px;
        background-color: white;
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      .solutions-header {
        text-align: center;
        max-width: 900px;
        margin-bottom: 40px;
        
      }

      .solutions-title {
        font-size: 28px;
        font-weight: bold;
        margin-bottom: 10px;
        letter-spacing:0px;
        color:black;
      }

      .solutions-subtitle {
        color: black;
        font-size: 18px;
      }

      .solutions-grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 25px;
        max-width: 1200px;
        width: 100%;
      }

      .solution-card {
        background: #fff;
        border-radius: 10px;
        overflow: hidden;
        box-shadow: 0 4px 12px rgba(0,0,0,0.1);
        display: flex;
        flex-direction: column;
        opacity: 0;
        transform: translateY(50px);
        transition: opacity 0.6s ease, transform 0.6s ease;
      }

      .solution-card.visible {
        opacity: 1;
        transform: translateY(0);
      }

      /* Random animations */
      .from-left { transform: translateX(-100px); }
      .from-right { transform: translateX(100px); }
      .from-bottom { transform: translateY(100px); }
      .from-top { transform: translateY(-100px); }

      .solution-card.visible.from-left,
      .solution-card.visible.from-right,
      .solution-card.visible.from-bottom,
      .solution-card.visible.from-top {
        transform: translateX(0) translateY(0);
        opacity: 1;
      }

      .solution-image {
        width: 100%;
        height: 200px;
        object-fit: cover;
        transition: transform 0.4s ease;
      }

      .solution-card:hover .solution-image {
        transform: scale(1.1);
      }

      .solution-content {
        padding: 20px;
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }

      .solution-title {
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 10px;
        color:black;
      }

      .solution-desc {
        font-size: 16px;
        color: black;
        text-align:justify;
       
      }

      /* Responsiveness */
      @media (max-width: 1024px) {
        .solutions-grid {
          grid-template-columns: repeat(2, 1fr);
        }
      }

      @media (max-width: 600px) {
        .solutions-grid {
          grid-template-columns: 1fr;
        }
      }
    `;
    document.head.appendChild(style);

    const cards = containerRef.current.querySelectorAll(".solution-card");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.2 }
    );

    const directions = ["from-left", "from-right", "from-top", "from-bottom"];
    cards.forEach((card) => {
      const randomClass =
        directions[Math.floor(Math.random() * directions.length)];
      card.classList.add(randomClass);
      observer.observe(card);
    });

    return () => {
      document.head.removeChild(style);
      observer.disconnect();
    };
  }, []);

  const solutions = [
    {
      img: "/image/telemed.jpg",
      title: "Telemedicine & Virtual Care",
      desc: "Enabling remote consultations, digital health records, and continuous patient monitoring with secure telehealth platforms."
    },
    {
      img: "/image/wearable.webp",
      title: "Wearable Health Tech",
      desc: "Innovating with smart wearables and biosensors for real-time health tracking, preventive care, and personalized treatment insights."
    },
    {
      img: "/image/genomics.jpg",
      title: "Genomics & Precision Medicine",
      desc: "Leveraging genomics, AI, and big data to deliver personalized therapies, improve diagnostics, and accelerate medical research."
    },
    {
      img: "/image/ai-in-healthcare-a-new-kind-of-digital-health.png",
      title: "AI in Healthcare",
      desc: "Applying AI and machine learning for faster diagnostics, medical imaging analysis, drug discovery, and clinical decision support."
    },
    {
      img: "/image/Ai-In-Healthcare-3.png",
      title: "Robotics & Smart Surgery",
      desc: "Enhancing surgical precision and patient outcomes through robotic-assisted surgeries and next-gen medical devices."
    },
    {
      img: "/image/Health-Data-Analyst.jpg",
      title: "Healthcare Data & Analytics",
      desc: "Harnessing big data, interoperability, and predictive analytics to optimize hospital operations and improve patient care."
    }
  ];

  return (
    <div className="solutions-container" ref={containerRef}>
      <div className="solutions-header">
        <h2 className="solutions-title">Health Sciences Technology Solutions</h2>
        <p className="solutions-subtitle">
          Transforming healthcare with digital innovation, AI, genomics, and smart devices for better patient outcomes and advanced medical research.
        </p>
      </div>

      <div className="solutions-grid">
        {solutions.map((item, index) => (
          <div className="solution-card" key={index}>
            <img src={item.img} alt={item.title} className="solution-image" />
            <div className="solution-content">
              <h3 className="solution-title">{item.title}</h3>
              <p className="solution-desc">{item.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HealthSciencesSolutions;
